
import React from 'react'
import WorkuploadCard from './WorkuploadCard'
import { useNavigate } from 'react-router-dom'
import { Bar } from 'react-chartjs-2'
import { WorkUploadChart } from '../../../../../Helper/Data'

export default function WorkUploadCardManage(props) {

    const { Countdata, HeaderMonthID, HeaderFinancialYear, MonthValue, YearValue, YearLabel, MonthLabel, WardValue, WardLabel, ProjectTypeId, DashboardName } = props
    const workUploadNavigate = (name, screenFlag) => {

        if (name === "Agency") {
            navigate(`/roadworkupload?name=${name}&Year=${YearValue}&YLable=${YearLabel}&Month=${MonthValue}&MLable=${MonthLabel}&WardName=${WardValue}&WLable=${WardLabel}&ProjectTypeId=${ProjectTypeId}&DashboardName=${DashboardName}`)
        } else if (name === "Junior / Deputy Engineer") {
            navigate(`/roadworkupload?name=${name}&Year=${YearValue}&YLable=${YearLabel}&Month=${MonthValue}&MLable=${MonthLabel}&WardName=${WardValue}&WLable=${WardLabel}&ProjectTypeId=${ProjectTypeId}&DashboardName=${DashboardName}`)
        }
    }
    const navigate = useNavigate()

    const Targetdata = {

        labels: ['Agency ', 'JE',],
        datasets: [
            {
                label: '',
                data: [
                    Countdata && Countdata?.AgencyTotalCount,
                    Countdata && Countdata?.JE_DETotalCount,
                    // 10, 20
                ],
                backgroundColor: [
                    "#cc2836", '#FFB300', "#253150"
                ],
                options: {
                    scales: {
                        xAxes: [{
                            barPercentage: 0.1
                        }]
                    }
                }
            },

        ],
    };

    return (
        <div className='row'>
            <div className='col-lg-8'>
                <div className='row ps-lg-3'>
                    <div className="col-12">
                        <h5 className="ps-2 py-2 pt-2">Work Upload</h5>
                    </div>
                    <div className="col-lg-6 col-md-6 col-12">
                        <WorkuploadCard
                            heading='Agency'
                            count={Countdata.AgencyTotalCount ? Countdata.AgencyTotalCount : '0'}
                            imgPath='./assets/img/public-relations.png'
                            cardName='wwork_img'
                            navLink='/roadworkupload'
                            workUploadNavigate={workUploadNavigate}
                        />
                    </div>
                    <div className="col-lg-6 col-md-6 col-12 " >
                        <WorkuploadCard
                            headstyle='head_j_d_e'
                            heading='Junior / Deputy Engineer'
                            count={Countdata.JE_DETotalCount ? Countdata.JE_DETotalCount : '0'}
                            imgPath='./assets/img/manager.png'
                            cardName='wwork_img'
                            navLink='/roadworkupload'
                            countText='count_head'
                            workUploadNavigate={workUploadNavigate}
                        />
                    </div>
                </div>

            </div>
            <div className="col-12 col-lg-4">
                <div className="upload_chart bg-white">
                    {
                        (Countdata?.AgencyTotalCount != 0) || (Countdata?.JE_DETotalCount != 0) ?
                            <Bar
                                // height={150}
                                options={WorkUploadChart}
                                data={Targetdata}
                            />
                            :
                            <div className='text-danger text-center pt-lg-5 fw-bolder'>
                                No Data Found
                            </div>
                    }
                </div>
            </div>
        </div>
    )
}






